import { Language } from '@/types';

export const translations = {
  // Landing page
  'landing.title': {
    nl: 'Bouw betere gewoontes op',
    fr: 'Construisez de meilleures habitudes',
    en: 'Build better habits'
  },
  'landing.subtitle': {
    nl: 'Zonder stress. Zonder account.',
    fr: 'Sans stress. Sans compte.',
    en: 'No stress. No account.'
  },
  'landing.feature.track': {
    nl: 'Volg dagelijks je gewoontes',
    fr: 'Suivez vos habitudes quotidiennement',
    en: 'Track your habits daily'
  },
  'landing.feature.nudge': {
    nl: 'Herinneringen vooraf + een duwtje als je vergeet',
    fr: 'Rappels avant + un coup de pouce si vous oubliez',
    en: 'Reminders before + a nudge when you forget'
  },
  'landing.feature.free': {
    nl: '100% gratis — voor altijd',
    fr: '100% gratuit — pour toujours',
    en: '100% free — forever'
  },
  'landing.feature.noAccount': {
    nl: 'Geen account nodig',
    fr: 'Pas de compte nécessaire',
    en: 'No account needed'
  },
  'landing.feature.privacy': {
    nl: 'Je gegevens verlaten nooit je telefoon',
    fr: 'Vos données ne quittent jamais votre téléphone',
    en: 'Your data never leaves your phone'
  },
  'landing.feature.ai': {
    nl: 'AI coach die je motiveert',
    fr: 'Coach IA qui vous motive',
    en: 'AI coach that motivates you'
  },
  'landing.cta': {
    nl: 'Start nu',
    fr: 'Commencez maintenant',
    en: 'Start now'
  },
  'landing.question': {
    nl: 'Kies de gewoontes die je wil verbeteren',
    fr: 'Choisissez les habitudes à améliorer',
    en: 'Pick the habits you want to improve'
  },
  'landing.footer': {
    nl: 'Van de makers van',
    fr: 'Des créateurs de',
    en: 'From the makers of'
  },

  // Categories
  'category.fitness': {
    nl: 'Fitness & Beweging',
    fr: 'Fitness & Mouvement',
    en: 'Fitness & Movement'
  },
  'category.fitness.desc': {
    nl: 'Meer bewegen, sterker worden',
    fr: 'Bouger plus, devenir plus fort',
    en: 'Move more, get stronger'
  },
  'category.sleep': {
    nl: 'Slaap & Rust',
    fr: 'Sommeil & Repos',
    en: 'Sleep & Rest'
  },
  'category.sleep.desc': {
    nl: 'Beter slapen, meer energie',
    fr: 'Mieux dormir, plus d\'énergie',
    en: 'Sleep better, more energy'
  },
  'category.mindfulness': {
    nl: 'Mindfulness & Stress',
    fr: 'Pleine conscience & Stress',
    en: 'Mindfulness & Stress'
  },
  'category.mindfulness.desc': {
    nl: 'Kalmer worden, focus verbeteren',
    fr: 'Devenir plus calme, améliorer la concentration',
    en: 'Become calmer, improve focus'
  },
  'category.learning': {
    nl: 'Leren & Groeien',
    fr: 'Apprendre & Grandir',
    en: 'Learn & Grow'
  },
  'category.learning.desc': {
    nl: 'Nieuwe skills, meer lezen',
    fr: 'Nouvelles compétences, plus de lecture',
    en: 'New skills, more reading'
  },
  'category.money': {
    nl: 'Geld & Budget',
    fr: 'Argent & Budget',
    en: 'Money & Budget'
  },
  'category.money.desc': {
    nl: 'Beter omgaan met geld',
    fr: 'Mieux gérer son argent',
    en: 'Better money management'
  },
  'category.cyber': {
    nl: 'Cyberbeveiliging',
    fr: 'Cybersécurité',
    en: 'Cybersecurity'
  },
  'category.cyber.desc': {
    nl: 'Veiliger online, betere wachtwoorden',
    fr: 'Plus sûr en ligne, meilleurs mots de passe',
    en: 'Safer online, better passwords'
  },
  'category.productivity': {
    nl: 'Productiviteit',
    fr: 'Productivité',
    en: 'Productivity'
  },
  'category.productivity.desc': {
    nl: 'Meer gedaan krijgen, minder stress',
    fr: 'Accomplir plus, moins de stress',
    en: 'Get more done, less stress'
  },
  'category.nutrition': {
    nl: 'Voeding & Gezondheid',
    fr: 'Nutrition & Santé',
    en: 'Nutrition & Health'
  },
  'category.nutrition.desc': {
    nl: 'Gezonder eten, meer energie',
    fr: 'Manger plus sainement, plus d\'énergie',
    en: 'Eat healthier, more energy'
  },
  'category.social': {
    nl: 'Sociaal & Relaties',
    fr: 'Social & Relations',
    en: 'Social & Relationships'
  },
  'category.social.desc': {
    nl: 'Betere relaties, meer connectie',
    fr: 'Meilleures relations, plus de connexion',
    en: 'Better relationships, more connection'
  },

  // Onboarding
  'onboarding.back': {
    nl: 'Terug',
    fr: 'Retour',
    en: 'Back'
  },
  'onboarding.next': {
    nl: 'Volgende',
    fr: 'Suivant',
    en: 'Next'
  },
  'onboarding.start': {
    nl: 'Start!',
    fr: 'Commencer!',
    en: 'Start!'
  },
  'onboarding.step': {
    nl: 'Stap {current} van {total}',
    fr: 'Étape {current} sur {total}',
    en: 'Step {current} of {total}'
  },
  'onboarding.chooseCategory': {
    nl: 'Welke gewoonte wil je verbeteren?',
    fr: 'Quelle habitude voulez-vous améliorer?',
    en: 'Which habit do you want to improve?'
  },
  'onboarding.hint': {
    nl: 'Je kunt later altijd meer toevoegen of wijzigen',
    fr: 'Vous pouvez toujours en ajouter ou modifier plus tard',
    en: 'You can always add or change more later'
  },
  'onboarding.chooseTemplate': {
    nl: 'Wat past bij jou?',
    fr: 'Qu\'est-ce qui vous convient?',
    en: 'What suits you?'
  },
  'onboarding.yourSchedule': {
    nl: 'Je weekschema',
    fr: 'Votre emploi du temps',
    en: 'Your weekly schedule'
  },
  'onboarding.totalTime': {
    nl: 'Totaal: {time} per week',
    fr: 'Total: {time} par semaine',
    en: 'Total: {time} per week'
  },
  'onboarding.adjustLater': {
    nl: 'Je kunt de tijden later nog aanpassen',
    fr: 'Vous pouvez encore ajuster les horaires plus tard',
    en: 'You can still adjust the times later'
  },

  // Tracker
  'tracker.today': {
    nl: 'Vandaag',
    fr: 'Aujourd\'hui',
    en: 'Today'
  },
  'tracker.stats': {
    nl: 'Statistieken',
    fr: 'Statistiques',
    en: 'Stats'
  },
  'tracker.coach': {
    nl: 'Coach',
    fr: 'Coach',
    en: 'Coach'
  },
  'tracker.settings': {
    nl: 'Instellingen',
    fr: 'Paramètres',
    en: 'Settings'
  },
  'tracker.day': {
    nl: 'Dag {current} van {total}',
    fr: 'Jour {current} sur {total}',
    en: 'Day {current} of {total}'
  },
  'tracker.streak': {
    nl: '{count} dagen streak',
    fr: '{count} jours consécutifs',
    en: '{count} day streak'
  },
  'tracker.completed': {
    nl: 'voltooid',
    fr: 'terminé',
    en: 'completed'
  },
  'tracker.tipOfTheDay': {
    nl: 'Tip van de dag',
    fr: 'Conseil du jour',
    en: 'Tip of the day'
  },
  'tracker.allDay': {
    nl: 'hele dag',
    fr: 'toute la journée',
    en: 'all day'
  },
  'tracker.addMore': {
    nl: 'Nog een gewoonte toevoegen',
    fr: 'Ajouter une autre habitude',
    en: 'Add another habit'
  },
  'tracker.editHabit': {
    nl: 'Gewoonte aanpassen',
    fr: 'Modifier l\'habitude',
    en: 'Edit habit'
  },
  'tracker.schedule': {
    nl: 'Planning',
    fr: 'Horaire',
    en: 'Schedule'
  },
  'tracker.time': {
    nl: 'Tijd',
    fr: 'Heure',
    en: 'Time'
  },
  'tracker.noTime': {
    nl: 'Hele dag',
    fr: 'Toute la journée',
    en: 'All day'
  },
  'tracker.disable': {
    nl: 'Pauzeren',
    fr: 'Mettre en pause',
    en: 'Pause'
  },
  'tracker.enable': {
    nl: 'Hervatten',
    fr: 'Reprendre',
    en: 'Resume'
  },
  'tracker.save': {
    nl: 'Opslaan',
    fr: 'Enregistrer',
    en: 'Save'
  },
  'tracker.disabled': {
    nl: 'Gepauzeerd',
    fr: 'En pause',
    en: 'Paused'
  },
  'tracker.oneTime': {
    nl: 'Eenmalig',
    fr: 'Une fois',
    en: 'One-time'
  },
  'tracker.tasks': {
    nl: 'Taken',
    fr: 'Tâches',
    en: 'Tasks'
  },
  'tracker.doFirst': {
    nl: 'Doe deze eerst',
    fr: 'Faites-les en premier',
    en: 'Do these first'
  },
  'tracker.habits': {
    nl: 'Gewoontes',
    fr: 'Habitudes',
    en: 'Habits'
  },
  'tracker.markOneTime': {
    nl: 'Eenmalige taak (verdwijnt na voltooiing)',
    fr: 'Tâche unique (disparaît après achèvement)',
    en: 'One-time task (disappears after completion)'
  },
  'tracker.recurring': {
    nl: 'Terugkerend',
    fr: 'Récurrent',
    en: 'Recurring'
  },
  'tracker.templateComplete': {
    nl: 'Je hebt "{name}" voltooid! 🎉',
    fr: 'Vous avez terminé "{name}" ! 🎉',
    en: 'You\'ve completed "{name}"! 🎉'
  },
  'tracker.chooseNewHabit': {
    nl: 'Kies een nieuwe gewoonte',
    fr: 'Choisir une nouvelle habitude',
    en: 'Choose a new habit'
  },
  'tracker.reminder': {
    nl: 'Herinnering',
    fr: 'Rappel',
    en: 'Reminder'
  },
  'tracker.reminderNone': {
    nl: 'Geen',
    fr: 'Aucun',
    en: 'None'
  },
  'tracker.reminderBefore': {
    nl: '10 min ervoor',
    fr: '10 min avant',
    en: '10 min before'
  },
  'tracker.reminderAt': {
    nl: 'Op het tijdstip',
    fr: 'À l\'heure',
    en: 'At the time'
  },
  'tracker.reminderAfter': {
    nl: '10 min erna (als niet afgevinkt)',
    fr: '10 min après (si non coché)',
    en: '10 min after (if not checked)'
  },
  'tracker.disabledHabits': {
    nl: 'Gepauzeerde gewoontes',
    fr: 'Habitudes en pause',
    en: 'Paused habits'
  },
  'tracker.tapToEnable': {
    nl: 'Tik om te hervatten',
    fr: 'Appuyez pour reprendre',
    en: 'Tap to resume'
  },
  'tracker.resetToDefault': {
    nl: 'Terugzetten naar standaard',
    fr: 'Réinitialiser par défaut',
    en: 'Reset to default'
  },

  // Days of week
  'day.ma': { nl: 'ma', fr: 'lu', en: 'mon' },
  'day.di': { nl: 'di', fr: 'ma', en: 'tue' },
  'day.wo': { nl: 'wo', fr: 'me', en: 'wed' },
  'day.do': { nl: 'do', fr: 'je', en: 'thu' },
  'day.vr': { nl: 'vr', fr: 've', en: 'fri' },
  'day.za': { nl: 'za', fr: 'sa', en: 'sat' },
  'day.zo': { nl: 'zo', fr: 'di', en: 'sun' },

  // Full day names
  'dayFull.ma': { nl: 'maandag', fr: 'lundi', en: 'monday' },
  'dayFull.di': { nl: 'dinsdag', fr: 'mardi', en: 'tuesday' },
  'dayFull.wo': { nl: 'woensdag', fr: 'mercredi', en: 'wednesday' },
  'dayFull.do': { nl: 'donderdag', fr: 'jeudi', en: 'thursday' },
  'dayFull.vr': { nl: 'vrijdag', fr: 'vendredi', en: 'friday' },
  'dayFull.za': { nl: 'zaterdag', fr: 'samedi', en: 'saturday' },
  'dayFull.zo': { nl: 'zondag', fr: 'dimanche', en: 'sunday' },

  // Coach
  'coach.title': {
    nl: 'Je Coach',
    fr: 'Votre Coach',
    en: 'Your Coach'
  },
  'coach.placeholder': {
    nl: 'Typ je vraag...',
    fr: 'Tapez votre question...',
    en: 'Type your question...'
  },
  'coach.privacy': {
    nl: 'Je coach draait 100% lokaal op je telefoon. Geen data wordt verstuurd.',
    fr: 'Votre coach fonctionne 100% localement sur votre téléphone. Aucune donnée n\'est envoyée.',
    en: 'Your coach runs 100% locally on your phone. No data is sent.'
  },
  'coach.loading': {
    nl: 'AI coach wordt geladen...',
    fr: 'Chargement du coach IA...',
    en: 'Loading AI coach...'
  },

  // Settings
  'settings.title': {
    nl: 'Instellingen',
    fr: 'Paramètres',
    en: 'Settings'
  },
  'settings.language': {
    nl: 'Taal',
    fr: 'Langue',
    en: 'Language'
  },
  'settings.notifications': {
    nl: 'Meldingen',
    fr: 'Notifications',
    en: 'Notifications'
  },
  'settings.reminderTime': {
    nl: 'Standaard herinneringstijd',
    fr: 'Heure de rappel par défaut',
    en: 'Default reminder time'
  },
  'settings.resetProgress': {
    nl: 'Vanaf nul herbeginnen',
    fr: 'Recommencer à zéro',
    en: 'Start from scratch'
  },
  'settings.resetConfirm': {
    nl: 'Typ "RESET" om te bevestigen',
    fr: 'Tapez "RESET" pour confirmer',
    en: 'Type "RESET" to confirm'
  },
  'settings.resetWarning': {
    nl: 'Dit verwijdert al je voortgang en gewoontes. Dit kan niet ongedaan worden gemaakt.',
    fr: 'Cela supprimera toute votre progression et vos habitudes. Cette action est irréversible.',
    en: 'This will delete all your progress and habits. This cannot be undone.'
  },
  'settings.cancel': {
    nl: 'Annuleren',
    fr: 'Annuler',
    en: 'Cancel'
  },
  'settings.yourHabits': {
    nl: 'Je gewoontes',
    fr: 'Vos habitudes',
    en: 'Your habits'
  },
  'settings.stopHabit': {
    nl: 'Stoppen',
    fr: 'Arrêter',
    en: 'Stop'
  },
  'settings.noHabits': {
    nl: 'Geen gewoontes actief',
    fr: 'Aucune habitude active',
    en: 'No active habits'
  },
  'settings.addHabit': {
    nl: 'Toevoegen',
    fr: 'Ajouter',
    en: 'Add'
  },

  // Cross-sell
  'crossSell.cyber': {
    nl: 'Ook je digitale gewoontes verbeteren?',
    fr: 'Améliorer aussi vos habitudes numériques?',
    en: 'Also improve your digital habits?'
  },
  'crossSell.discover': {
    nl: 'Ontdek Easy Cyber Protection',
    fr: 'Découvrez Easy Cyber Protection',
    en: 'Discover Easy Cyber Protection'
  },
} as const;

export type TranslationKey = keyof typeof translations;

export function t(key: TranslationKey, lang: Language, params?: Record<string, string | number>): string {
  let translation: string = translations[key]?.[lang] || translations[key]?.['nl'] || key;

  if (params) {
    for (const [paramKey, value] of Object.entries(params)) {
      translation = translation.replace(`{${paramKey}}`, String(value));
    }
  }

  return translation;
}

export function getLocalizedString(obj: { nl: string; fr: string; en: string }, lang: Language): string {
  return obj[lang] || obj.nl;
}
